import PropTypes from "prop-types";

const TONE = {
  green: "rec-chip-green",
  amber: "rec-chip-amber",
  red: "rec-chip-red",
  teal: "rec-chip-teal",
  gray: "rec-chip-gray",
  info: "rec-chip-info",
};

export default function Chip({ tone, className, children }) {
  const cls = `rec-chip ${TONE[tone] || TONE.gray}${className ? ` ${className}` : ""}`;
  return <span className={cls}>{children}</span>;
}

Chip.propTypes = {
  tone: PropTypes.oneOf(["green", "amber", "red", "teal", "gray", "info"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

Chip.defaultProps = {
  tone: "gray",
  className: "",
  children: null,
};
